"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomMutation = void 0;
var _client = require("@apollo/client");
const useCustomMutation = (mutation, options) => {
  /*
   * This is used so that we only pass the variables to the mutation function and don't care
   * about any other properties that the mutating action has
   * */
  const mutationFunc = action => (variables, optimisticResponse) => action({
    variables,
    optimisticResponse
  }).then(_ref => {
    let {
      errors,
      data
    } = _ref;
    if (errors && errors.length > 0) {
      return Promise.reject();
    }
    return {
      data
    };
  }).catch(() => Promise.reject());
  const [action] = (0, _client.useMutation)(mutation, {
    ...options
  });
  return {
    action: mutationFunc(action)
  };
};
exports.useCustomMutation = useCustomMutation;